var _ellipse, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAcceptancePending(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 8.99998,
    cy: 9.5,
    rx: 8.99998,
    ry: 9,
    fill: "#FF7236"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.9085 6.88919C12.9808 6.91804 13.0428 6.96788 13.0865 7.0323C13.1301 7.09671 13.1535 7.17274 13.1536 7.25057V11.7481C13.1535 11.826 13.1301 11.902 13.0865 11.9664C13.0428 12.0308 12.9808 12.0807 12.9085 12.1095L9.14408 13.6153C9.05125 13.6524 8.9477 13.6524 8.85487 13.6153L5.09044 12.1095C5.01825 12.0806 4.95638 12.0307 4.91279 11.9663C4.86921 11.9019 4.8459 11.8259 4.84589 11.7481V7.25057C4.8459 7.1728 4.86921 7.09682 4.91279 7.03241C4.95638 6.968 5.01825 6.91812 5.09044 6.88919L8.71052 5.44105L8.7126 5.44053L8.85487 5.38342C8.94785 5.34615 9.05162 5.34615 9.1446 5.38342L9.28687 5.44053L9.28894 5.44105L12.9085 6.88919ZM12.1951 7.16282L8.99973 8.44117L5.80439 7.16282L5.36512 7.33884V7.54653L8.74012 8.89653V13.0099L8.99973 13.1137L9.25935 13.0099V8.89705L12.6343 7.54705V7.33936L12.1951 7.16282Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAcceptancePending);
export default __webpack_public_path__ + "static/media/acceptance_pending.7ec9bac929f5a172c123173aad70805e.svg";
export { ForwardRef as ReactComponent };